import React, { Component } from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './MapGL.styles';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import marker from '../../../assets/marker.png';

import SelectButton from '../../inputs/selectbutton/SelectButton';

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

export class MapGL extends Component {
  state = {
    map: null,
    type:
      this.props.type === 'default'
        ? localStorage.getItem('airfinder_selected_layer') || 'default'
        : this.props.type
  };
  mapStyles = {
    clear: {
      version: 8,
      name: 'clean',
      sources: {},
      glyphs: 'mapbox://fonts/mapbox/{fontstack}/{range}.pbf',
      layers: [
        {
          id: 'background',
          type: 'background',
          paint: { 'background-color': 'white' }
        }
      ]
    },
    satellite: 'mapbox://styles/mapbox/satellite-streets-v9',
    default: 'mapbox://styles/mapbox/streets-v9'
  };
 
  componentDidUpdate() {
    if (this.state.map && this.state.map.loaded() && this.props.onUpdate) {
      this.props.onUpdate(this.state.map);
    }
  }

  componentDidMount() {
    this.loadMap();
  }

  loadMap = () => {
    setTimeout(() => {
      let mapStyles =
        this.state.type in this.mapStyles
          ? this.mapStyles[this.state.type]
          : this.mapStyles['default'];
      const map = new mapboxgl.Map({
        container: this.refs.mapContainer,
        style: mapStyles,
        center: [-96, 37.8],
        zoom: 3,
        dragPan: true,
        ...this.props.options
      });
      this.setState({ map });
      if (this.props.onClick) {
        map.on('click', this.props.onClick);
      }
      map.addControl(new mapboxgl.NavigationControl());
      if (this.props.beforeLoad) {
        this.props.beforeLoad(map);
      }
      if (this.props.onLoad) {
        map.on('load', () => {
          this.props.onLoad(map);
        });
        map.on('style.load', () => {
          map.loadImage(marker, (error, image) => {
            if (error) return;
            map.addImage('custom-marker', image);
          });
          if (this.props.onStyleChange) {
            this.props.onStyleChange();
          }
          this.props.onLoad(map);
        });
      }
      if (this.props.onMove) {
        map.on('move', () => {
          this.props.onMove(map);
        });
      }
    }, 100);
  };
  handleTypeChange = type => {
    if (this.state.map && type) {
      if (type in this.mapStyles) {
        localStorage.setItem('airfinder_selected_layer', type);
        this.state.map.setStyle(this.mapStyles[type]);
      } else {
        this.state.map.setStyle(this.mapStyles['default']);
      }
      this.setState({ type });
    }
  };
  render() {
    return (
      <div className={css(styles.map, this.props.styles)} ref="mapContainer">
        {this.props.showSuperTagLegend && (
          <div className={css(styles.superTagLegend)}>
            <div className={css(styles.legendItem)}>
              <div className={css(styles.circle, styles.gps)} />
              <Translate
                className={css(styles.legendText)}
                value="models.tag.gps"
              />
            </div>
            <div className={css(styles.legendItem)}>
              <div className={css(styles.circle, styles.cellId)} />
              <Translate
                className={css(styles.legendText)}
                value="models.tag.cellId"
              />
            </div>
            <div className={css(styles.legendItem)}>
              <div className={css(styles.circle, styles.wifi)} />
              <Translate
                className={css(styles.legendText)}
                value="models.tag.wifi"
              />
            </div>
          </div>
        )}
        <div className={css(styles.typeSelect)}>
          {this.props.type !== 'clear' && (
            <SelectButton
              onChange={this.handleTypeChange}
              value={
                this.state.type in this.mapStyles ? this.state.type : 'default'
              }
              options={[
                {
                  label: I18n.t('map'),
                  value: 'default'
                },
                {
                  label: I18n.t('satellite'),
                  value: 'satellite'
                }
              ]}
            />
          )}
        </div>
      </div>
    );
  }
}

export default MapGL;



// WEBPACK FOOTER //
// ./src/components/data/mapgl/MapGL.js